import React from 'react'
import ComingSoon from '../components/ComingSoon'

const StandardsPublish = () => {
  return (
    <ComingSoon />
  )
}

export default StandardsPublish